import { INTERVENE_USER_TABS } from '../constants/interveneApi';

export const SESSION_WINDOW_SECONDS = 24 * 60 * 60;
export const FIFTEEN_MIN_WINDOW_SECONDS = 15 * 60;

/** Tab bucket windows — mirror ActiveChatUser._build_tab_query. */
export const TAB_WINDOW_SECONDS = {
  [INTERVENE_USER_TABS.INTERVENE]: SESSION_WINDOW_SECONDS,
  [INTERVENE_USER_TABS.RECENT_15M]: FIFTEEN_MIN_WINDOW_SECONDS,
  [INTERVENE_USER_TABS.ACTIVE_24H]: SESSION_WINDOW_SECONDS,
};

export function getTabWindowSeconds(tabValue) {
  if (!tabValue) return SESSION_WINDOW_SECONDS;
  return TAB_WINDOW_SECONDS[tabValue] ?? SESSION_WINDOW_SECONDS;
}

export function parseLastActiveDate(value) {
  if (value == null || value === '') return null;

  if (typeof value === 'number') {
    const date = new Date(value > 9999999999 ? value : value * 1000);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const str = String(value).trim();
  const withZone = str.includes('Z') || /[+-]\d{2}:\d{2}$/.test(str) ? str : `${str}Z`;
  const date = new Date(withZone);
  if (!Number.isNaN(date.getTime())) return date;

  const fallback = new Date(str);
  return Number.isNaN(fallback.getTime()) ? null : fallback;
}

export function getRemainingSeconds(lastActive, windowSeconds = SESSION_WINDOW_SECONDS) {
  const date = parseLastActiveDate(lastActive);
  if (!date) return 0;

  const diffSec = Math.floor((Date.now() - date.getTime()) / 1000);
  const remaining = windowSeconds - diffSec;
  return remaining > 0 ? remaining : 0;
}

/** @deprecated Use getRemainingSeconds — kept for composer/session expiry checks. */
export function getSessionRemainingSeconds(lastActive) {
  return getRemainingSeconds(lastActive, SESSION_WINDOW_SECONDS);
}

export function getTabRemainingSeconds(lastActive, tabValue) {
  return getRemainingSeconds(lastActive, getTabWindowSeconds(tabValue));
}

export function formatCountdown(totalSeconds) {
  const hrs = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  return `${hrs}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

export function isSessionExpired(lastActive) {
  return getSessionRemainingSeconds(lastActive) === 0;
}

export function isTabWindowExpired(lastActive, tabValue) {
  return getTabRemainingSeconds(lastActive, tabValue) === 0;
}

export function getLastActiveFromUser(user) {
  if (!user) return null;
  return (
    user.last_active_date ||
    user.last_inbound_message?.created_at ||
    user.last_inbound_message?.timestamp ||
    user.last_user_message?.created_at ||
    user.last_user_message?.timestamp ||
    null
  );
}
